import {graphql} from 'react-apollo';
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import {SAVE_TRAVEL_PAY_MUTATION} from '../../queries';
import {compose, withHandlers} from 'recompose';
import {buildTsInput} from '../../../shared/utils/queries';

// Saving On Call data
//
const saveTravelPay = graphql(SAVE_TRAVEL_PAY_MUTATION, {
  props: ({
    ownProps: {
      setError,
      updateTimesheetData,
      setSavePending,
      timesheet,
      timesheetSource,
      activeEntry,
      activeRow
    },
    mutate
  }) => ({
    saveTravelPay(date, previousSelection, newSelection) {
      if ((previousSelection || '') === (newSelection || '')) {
        return;
      }
      const sourceEntry = find(
        timesheet.travelTimeRow.entries,
        e => e.Date === date
      );
      const entry = {
        id: sourceEntry.id,
        Date: date,
        TravelPay: newSelection
      };
      setSavePending({
        [entry.id]: true
      });
      return mutate({
        variables: {
          ...buildTsInput(timesheet),
          row: {},
          entry
        },

        optimisticResponse: {
          __typename: 'Mutation',
          // __optimistic: true,
          saveTravelPay: {
            __typename: 'TimesheetEntry',
            OvernightCompensation: false,
            TimeAllocation: 0,
            ...sourceEntry,
            ...entry
          }
        },

        update: (store, {data: {saveTravelPay}}) => {
          const entryIndex = findIndex(
            timesheetSource.travelTime,
            e => e.Date === date
          );
          updateTimesheetData(
            {
              travelTime: {
                [entryIndex]: {
                  // this could include a new id, so we need to do an explicit update
                  $merge: saveTravelPay
                }
              }
            },
            store
          );
        }
      })
        .catch(err => {
          setError(err);
        })
        .then(result => {
          if (sourceEntry) setSavePending({[sourceEntry.id]: false});
        });
    }
  })
});

const clearTravelPay = withHandlers({
  clearTravelPay: ({saveTravelPay, timesheet}) => () => {
    timesheet.travelTimeRow.entries.forEach(entry =>
      saveTravelPay(entry.Date, entry.Selection, null)
    );
  }
});

export default compose(saveTravelPay, clearTravelPay);
